// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fixed-bottom-bar_wrapper__yg-pY","container":"fixed-bottom-bar_container__3RHBD"};